// zh translations — extracted mechanically from LanguageContext.jsx (Team Foundation).
// Feature-specific keys belong in src/i18n/extensions/*.js instead.
const zh = {
    // Common
    "common.loading": "加载中...",
    "common.save": "保存",
    "common.cancel": "取消",
    "common.delete": "删除",
    "common.edit": "编辑",
    "common.submit": "提交",
    "common.logout": "退出登录",
    "common.login": "登录",
    "common.register": "注册",
    
    // Auth
    "auth.welcome": "欢迎",
    "auth.signIn": "登录您的账户",
    "auth.email": "电子邮箱",
    "auth.password": "密码",
    "auth.loginButton": "登录",
    
    // Navigation
    "nav.dashboard": "仪表盘",
    "nav.releases": "发行",
    "nav.payouts": "付款",
    "nav.support": "支持",
    "nav.referrals": "推荐",
    "nav.profile": "个人资料",
    
    // Dashboard
    "dashboard.welcome": "欢迎",
    "dashboard.subtitle": "管理您的音乐，跟踪发行并查看收入。",
    "dashboard.totalReleases": "总发行数",
    "dashboard.totalTracks": "总曲目数",
    "dashboard.balance": "当前余额",
    "dashboard.withdrawable": "可提现",
    "dashboard.recentReleases": "最近发行",
    "dashboard.newRelease": "新发行",
    "dashboard.requestPayout": "申请付款",
    
    // Analytics
    "analytics.title": "数据统计",
    "analytics.subtitle": "追踪您发行作品的表现",
    "analytics.totalStreams": "总播放量",
    "analytics.listeners": "听众",
    "analytics.estimatedEarnings": "预估收益",
    "analytics.monthlyGrowth": "月增长",
    "analytics.streamsChart": "播放量图表",
    "analytics.platformDistribution": "平台分布",
    "analytics.topTracks": "热门曲目",
    "analytics.trackName": "曲目名称",
    "analytics.streams": "次播放",
    "analytics.comingSoonTitle": "即将推出",
    "analytics.comingSoonDesc": "详细的数据分析和洞察即将上线。通过artist.tools集成，您将能够在一个地方追踪所有平台数据。",
    "common.comingSoon": "即将推出",
    
    // Payouts
    "payouts.title": "管理您的收入",
    "payouts.subtitle": "轻松提取您的音乐收入。最低提款金额为$50。",
    "payouts.fastPayment": "快速支付",
    "payouts.secureTransfer": "安全转账",
    "payouts.totalBalance": "总余额",
    "payouts.withdrawableBalance": "可提现金额",
    "payouts.requestPayout": "申请付款",
    "payouts.payoutHistory": "付款历史",
    "payouts.noPayouts": "暂无付款申请",
    "payouts.noPaymentMethod": "无支付方式",
    "payouts.addMethodDesc": "添加支付方式以提取您的收入。",
    "payouts.addMethod": "添加支付方式",
    "payouts.changeMethodVerification": "更改当前支付方式需要邮箱验证",
    "payouts.availableBalance": "可用余额",
    "payouts.pendingBalance": "待处理余额",
    "payouts.withdrawalHistory": "提款历史",
    "payouts.requestWithdrawal": "申请提款",
    "payouts.minWithdrawal": "最低提款：$50",
    "payouts.manageEarnings": "管理您的收入",
    "payouts.createRequest": "创建付款申请",
    "payouts.amount": "金额",
    "payouts.accountHolder": "账户持有人",
    "payouts.bankName": "银行名称",
    "payouts.minAmount": "最低提款金额为$50",
    "payouts.insufficientBalance": "余额不足",
    "payouts.fillRequired": "请填写所有必填字段",
    "payouts.requestCreated": "付款申请已创建",
    "payouts.requestFailed": "申请失败",
    "payouts.minNotMet": "未达到最低金额",
    "payouts.minNotMetMsg": "您需要至少$50的可提现余额才能申请付款。",
    "payouts.statusRequested": "已申请",
    "payouts.statusPaid": "已支付",
    "payouts.paymentMethod": "支付方式",
    "payouts.bankTransfer": "银行转账",
    "payouts.paypalEmail": "PayPal邮箱",
    "payouts.paypalNote": "输入与您PayPal账户关联的邮箱地址",
    "payouts.fillPaypalRequired": "请输入PayPal邮箱和账户持有人姓名",
    "payouts.selectCountry": "选择您的国家",
    "payouts.tabProfile": "支付资料",
    "payouts.tabMethod": "支付方式",
    "payouts.tabRequests": "提款申请",
    "payouts.requirements": "提款要求",
    "payouts.completeProfile": "完善您的支付资料（身份和地址）",
    "payouts.addPaymentMethod": "添加支付方式（银行或PayPal）",
    "payouts.verifyPaymentMethod": "验证您的支付方式",
    "payouts.profileComplete": "已完成",
    "payouts.savedProfile": "已保存的资料信息",
    "payouts.fullName": "全名",
    "payouts.phoneNumber": "电话",
    "payouts.location": "位置",
    "payouts.profileType": "资料类型",
    "payouts.individual": "个人",
    "payouts.business": "企业/公司",
    "payouts.edit": "编辑",
    
    // Statuses
    "status.draft": "草稿",
    "status.submitted": "已提交",
    "status.approved": "已批准",
    "status.rejected": "已拒绝",
    "status.live": "上线",
    
    // Validation
    "validation.audioRequired": "音频文件为必填项",
    "validation.audioFormatWav": "音频文件必须为WAV或FLAC格式",
    "validation.titleRequired": "标题为必填项",
    "validation.titleLanguageRequired": "标题语言为必填项",
    "validation.primaryArtistRequired": "至少需要一位主要艺术家",
    "validation.primaryGenreRequired": "主要流派选择为必填项",
    "validation.explicitRequired": "内容类型选择为必填项",
    "validation.coverRequired": "封面图片为必填项",
    "validation.songwriterRequired": "至少需要一位词曲作者",
    "validation.contributorRequired": "至少需要一位贡献者",
    "validation.productionTeamRequired": "至少需要一位制作团队成员",
    "validation.platformRequired": "至少需要选择一个平台",
    "validation.releaseDateRequired": "发行日期为必填项",
    "validation.trackCountRequired": "EP/专辑至少需要2首曲目",
    "releases.track": "曲目",
    
    // Toast Messages
    "toast.saveSuccess": "保存成功",
    "toast.saveFailed": "保存失败",
    "toast.deleteSuccess": "删除成功",
    "toast.uploadSuccess": "上传成功",
    "toast.submitSuccess": "提交成功",
    "toast.loginSuccess": "登录成功",
    "toast.copySuccess": "已复制到剪贴板",
    "toast.errorOccurred": "发生错误",
    "toast.pleaseFixErrors": "请修复此部分的错误",
    
    // Spotify
    "spotify.comingSoon": "即将推出",
};

export default zh;
